import React from 'react';
import { Activity, Zap, BarChart3 } from 'lucide-react';

const ValueProps = () => {
  const props = [
    {
      title: 'CADENCIA INTELIGENTE',
      desc: 'Algoritmos avanzados que ajustan tu ritmo en tiempo real basándose en tu fatiga neuromuscular.',
      icon: <Zap className="w-8 h-8 text-pacer-start" />,
    },
    {
      title: 'CARGA DE ENTRENAMIENTO',
      desc: 'Monitoreo preciso de la carga crónica y aguda para prevenir el sobreentrenamiento y lesiones.',
      icon: <Activity className="w-8 h-8 text-success" />,
    },
    {
      title: 'FEEDBACK CENTRALIZADO',
      desc: 'Toda la telemetría de tu equipo sincronizada en un solo panel editorial de alto impacto.',
      icon: <BarChart3 className="w-8 h-8 text-pacer-end" />,
    }
  ];

  return (
    <section id="benefits" className="bg-surface py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <h2 className="font-lexend font-extrabold text-5xl tracking-tighter max-w-lg uppercase italic">
            CIENCIA APLICADA AL <span className="text-pacer-start">MOVIMIENTO</span>
          </h2>
          <p className="font-inter text-[#888] text-sm uppercase tracking-[0.2em] max-w-xs text-left md:text-right border-l-2 md:border-l-0 md:border-r-2 border-pacer-start pl-6 md:pl-0 md:pr-6 py-2">
            Métricas de élite para corredores que no aceptan menos que la perfección.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-1 shadow-2xl">
          {props.map((prop, idx) => (
            <div 
              key={idx} 
              className="group bg-card p-12 hover:bg-[#2d2d2d] transition-all duration-500 flex flex-col items-start gap-8"
            >
              <div className="p-4 bg-background rounded-sm transform group-hover:rotate-12 transition-transform">
                {prop.icon}
              </div>
              <h3 className="font-lexend font-extrabold text-xl tracking-tighter uppercase italic translate-y-2 group-hover:translate-y-0 transition-transform">
                {prop.title}
              </h3>
              <p className="font-inter text-[#999] leading-relaxed text-sm">
                {prop.desc}
              </p>
              <div className="mt-auto pt-8">
                <div className="h-0.5 w-12 bg-pacer-start transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
